import { GantPoItemDetails } from "./gant-po-item-details";

export class GantPoDetails {
    poNumber: string;
    deliveryAddress: string;
    GantpoItemDetails: GantPoItemDetails[]
}